(function registerSearchOverlay(root, factory) {
  const api = factory();
  if (typeof module !== "undefined" && module.exports) module.exports = api;
  if (root) root.ProhatsSearchOverlay = api;
})(typeof window !== "undefined" ? window : globalThis, () => {
  function initializeSearchOverlay({
    trigger,
    overlay,
    input,
    suggestions,
    documentRef = document,
    requestFrame = requestAnimationFrame,
  }) {
    if (!trigger || !overlay || !input || !suggestions) return () => {};

    const setOpen = (open) => {
      overlay.classList.toggle("is-open", open);
      trigger.setAttribute("aria-expanded", String(open));
      if (open) requestFrame(() => input.focus());
      else suggestions.style.display = "none";
    };

    const onTrigger = (event) => {
      event.preventDefault();
      setOpen(!overlay.classList.contains("is-open"));
    };

    const onOutsideClick = (event) => {
      if (
        overlay.classList.contains("is-open") &&
        !overlay.contains(event.target) &&
        !trigger.contains(event.target)
      ) {
        setOpen(false);
      }
    };

    const onKeydown = (event) => {
      if (event.key === "Escape" && overlay.classList.contains("is-open")) {
        setOpen(false);
        trigger.focus();
      }
    };

    trigger.addEventListener("click", onTrigger);
    documentRef.addEventListener("click", onOutsideClick);
    documentRef.addEventListener("keydown", onKeydown);

    return () => {
      trigger.removeEventListener("click", onTrigger);
      documentRef.removeEventListener("click", onOutsideClick);
      documentRef.removeEventListener("keydown", onKeydown);
    };
  }

  return { initializeSearchOverlay };
});
